var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6248 29.5312H16.0415C15.4436 29.5312 14.9478 29.0354 14.9478 28.4375C14.9478 27.8396 15.4436 27.3438 16.0415 27.3438H30.6248C31.2228 27.3438 31.7186 27.8396 31.7186 28.4375C31.7186 29.0354 31.2228 29.5312 30.6248 29.5312Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6248 19.323H16.0415C15.4436 19.323 14.9478 18.8272 14.9478 18.2292C14.9478 17.6313 15.4436 17.1355 16.0415 17.1355H30.6248C31.2228 17.1355 31.7186 17.6313 31.7186 18.2292C31.7186 18.8272 31.2228 19.323 30.6248 19.323Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6248 9.1145H16.0415C15.4436 9.1145 14.9478 8.61867 14.9478 8.02075C14.9478 7.42284 15.4436 6.927 16.0415 6.927H30.6248C31.2228 6.927 31.7186 7.42284 31.7186 8.02075C31.7186 8.61867 31.2228 9.1145 30.6248 9.1145Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83311 10.573C5.55602 10.573 5.27894 10.4709 5.06019 10.2522L3.60186 8.79385C3.17894 8.37093 3.17894 7.67093 3.60186 7.24801C4.02477 6.8251 4.72477 6.8251 5.14769 7.24801L5.83311 7.93343L9.43519 4.33135C9.85811 3.90843 10.5581 3.90843 10.981 4.33135C11.4039 4.75426 11.4039 5.45426 10.981 5.87718L6.60602 10.2522C6.38727 10.4709 6.11019 10.573 5.83311 10.573Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83311 20.7813C5.55602 20.7813 5.27894 20.6792 5.06019 20.4604L3.60186 19.0021C3.17894 18.5792 3.17894 17.8792 3.60186 17.4563C4.02477 17.0333 4.72477 17.0333 5.14769 17.4563L5.83311 18.1417L9.43519 14.5396C9.85811 14.1167 10.5581 14.1167 10.981 14.5396C11.4039 14.9625 11.4039 15.6625 10.981 16.0854L6.60602 20.4604C6.38727 20.6792 6.11019 20.7813 5.83311 20.7813Z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83311 30.9895C5.55602 30.9895 5.27894 30.8874 5.06019 30.6687L3.60186 29.2104C3.17894 28.7874 3.17894 28.0874 3.60186 27.6645C4.02477 27.2416 4.72477 27.2416 5.14769 27.6645L5.83311 28.3499L9.43519 24.7479C9.85811 24.3249 10.5581 24.3249 10.981 24.7479C11.4039 25.1708 11.4039 25.8708 10.981 26.2937L6.60602 30.6687C6.38727 30.8874 6.11019 30.9895 5.83311 30.9895Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.9372ec5b22df3be246e48e33f5fc27f2.svg";
export { ForwardRef as ReactComponent };